import React from 'react';

import { MCButton, TextField } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';
import AlertManager from 'src/components/alert';

import { formatDuration, lang, remCss } from 'src/helpers';

import model from './model';
import LANG_CONST from 'src/helpers/lang/const';

const apiStateId = 'requestVerification';

const intervalId = 'SecurityPhone';

class Email extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  requestVerification = (e) => {
    e.preventDefault();

    if (model.state.user?.emailVerified && model.state.user.email === model.state.email) return;

    model.requestVerification((error, res) => {
      if (res?.ok) {
        AlertManager.popup(AlertManager.TYPES.INFO, {
          width: 550,
          title: LANG_CONST.text.verification_email_sent,
          actionButton: {
            label: LANG_CONST.buttons.got_it,
            action: (props) => props.hide()
          }
        });
      } else if (res?.expired) {
        model.setState({ resetEmailExpired: res.expired });
        this.timer(() => model.state.resetEmailExpired > Date.now(), intervalId);
      }
    });
  };

  cancel = (e) => {
    e.preventDefault();
    model.resetApiState(apiStateId);
    model.setState({ email: model.state.user.email, resetEmailExpired: 0 });
  };

  render() {
    const { handleChange, handleBlur } = model;
    const createState = model.getApiState(apiStateId);
    const { invalid, loading } = createState;

    const { blocked, expiredIn } = model.getBlock(model.state.resetEmailExpired);

    if (createState.error === 'BLOCKED') createState.errorMessage = '';

    if (createState.error === 'EMAIL_TAKEN') {
      invalid['email'] = createState.errorMessage;
      createState.error = '';
    }

    let blockedInMin = Math.ceil(expiredIn / 60);
    blockedInMin = `${blockedInMin} ${blockedInMin > 2 ? 'minutes' : 'minute'}`;

    const emailUnverified =
      !model.state.user?.emailVerified || model.state.user.email !== model.state.email;

    return (
      <form className={'mc-setting-change-pw'} onSubmit={this.requestVerification}>
        <div className={'mc-header'}>
          <div className={'mc-title'}>{lang.t(LANG_CONST.change_email)}</div>
        </div>
        <div className={'mc-form'}>
          <div className={'mc-flex-25-col mc-mlr30'}>
            <div className={'mc-flex-20 mc-flex-start'}>
              <div className={'mc-grow'}>
                <TextField
                  template={6}
                  label={LANG_CONST.email_address}
                  name={'email'}
                  value={model.input('email')}
                  onChange={(n, v) => {
                    model.resetApiState('requestVerification');
                    model.setStateSilent({ resetEmailExpired: 0 });
                    handleChange(n, v);
                  }}
                  onBlur={handleBlur}
                  invalid={invalid}
                />
              </div>
              <div className={'mc-grow mc-flex-10'} style={{ marginTop: remCss(37) }}>
                <MCButton
                  medium
                  primary={!emailUnverified}
                  secondary={emailUnverified}
                  light
                  label={lang.t(!emailUnverified ? LANG_CONST.verified : LANG_CONST.not_verified)}
                />
              </div>
            </div>

            {blocked && (
              <div className={'mc-label-418'}>
                {lang.t(LANG_CONST.notice.verify_code_sent_email, { blockedInMin })}
              </div>
            )}
          </div>
        </div>
        {emailUnverified && (
          <div className={'mc-bt mc-flex mc-p30'}>
            {createState.error && <p className='mc-error'>{createState.errorMessage}</p>}
            <div className={'mc-grow'}></div>
            {model.state.user.email !== model.state.email && (
              <MCButton
                onClick={this.cancel}
                medium
                primary
                radius
                light
                label={LANG_CONST.buttons.cancel}
                disabled={loading}
              />
            )}
            <MCButton
              medium
              radius
              disabled={blocked || loading}
              loading={loading}
              primary
              dark={!blocked}
              light={blocked}
              label={
                blocked
                  ? lang.t(LANG_CONST.buttons.send_verification_in, {
                      duration: formatDuration(expiredIn)
                    })
                  : lang.t(LANG_CONST.buttons.send_verification)
              }
              type={'submit'}
            />
          </div>
        )}
      </form>
    );
  }
}

export default Email;
